module.exports = __webpack_public_path__ + "img/sanhong.0062a824.png";